(function (utils, $) {
  var externalUrlRegExp = new RegExp("//" + location.host + "($|/)");
  utils.isExternalUrl = function (url) {
    var isMailtoLink = url.match("^mailto:");
    if (isMailtoLink) {
      return true;
    }
    var isLocal = url.match("^http") ? externalUrlRegExp.test(url) : true;
    return !isLocal;
  };

  utils.removeBaseUrl = function (url) {
    var baseUrlPattern = /^https?:\/\/[a-z:0-9.]+/;
    var result = "";

    var match = baseUrlPattern.exec(url);
    if (match != null) {
      result = match[0];
    }

    if (result.length > 0) {
      url = url.replace(result, "");
    }

    return url;
  };

  utils.removeQueryStringFromUrl = function (url) {
    return url.split("?")[0];
  };

  utils.getRestfulUrlValueForKey = function (url, key) {
    if (!url || !key) {
      return undefined;
    }

    url = utils.removeBaseUrl(url);
    var urlComponents = url.split("/");

    for (var i = 0; i < urlComponents.length - 1; i++) {
      if (urlComponents[i] === key) {
        return urlComponents[i + 1];
      }
    }
    return undefined; // key not found
  };

  utils.isWhite = function (colourString) {
    return colourString === "rgb(255, 255, 255)" || colourString === "#ffffff" || colourString === "white";
  };

  utils.isBlack = function (colourString) {
    return colourString === "rgb(0, 0, 0)" || colourString === "#000000" || colourString === "black";
  };

  utils.preloadImages = function (imageUrls, callback) {
    var count = imageUrls.length;
    if (count === 0 && callback) {
      callback();
    }
    var loaded = 0;
    $.each(imageUrls, function (index, imageUrl) {
      $("<img>")
        .attr("src", imageUrl)
        .on("load abort error", function () {
          loaded++;
          if (loaded === count) {
            if (callback) {
              callback();
            }
          }
        });
    });
  };

  utils.preloadImage = function (imageUrl, callback) {
    utils.preloadImages([imageUrl], callback);
  };

  // sets video src of an element and makes it responsive
  utils.setVideoSrc = function (videoElement, src, width, height) {
    if (videoElement.attr("src")) {
      return; // this video is already configured
    }
    videoElement.attr("width", width);
    videoElement.attr("height", height);
    videoElement.attr("src", src);
    videoElement.attr("style", "width:" + (width / height) * 100 + "vh; min-height:" + (height / width) * 100 + "vw");
  };

  utils.isIE = function (version) {
    var r = RegExp("msie" + (!isNaN(version) ? "\\s" + version : ""), "i");
    return r.test(navigator.userAgent);
  };

  Number.prototype.mod = function (n) {
    return ((this % n) + n) % n;
  };

  utils.isClickEventRequestingNewTab = function (event) {
    return event.metaKey || event.ctrlKey || event.which === 2;
  };

  utils.getSharedCount = function (url, completion) {
    url = encodeURIComponent(url || location.href);
    var arg = {
      url: "//" + (location.protocol == "https:" ? "sharedcount.appspot" : "api.sharedcount") + ".com/?url=" + url,
      cache: true,
      dataType: "json",
    };
    if ("withCredentials" in new XMLHttpRequest()) {
      arg.success = completion;
    } else {
      var cb = "sc_" + url.replace(/\W/g, "");
      window[cb] = completion;
      arg.jsonpCallback = cb;
      arg.dataType += "p";
    }
    return jQuery.ajax(arg);
  };

  utils.showDialog = function (title, bodyHtml) {
    $("<div id='generic-dialog'>" + bodyHtml + "</div>").dialog({
      open: function () {},
      draggable: false,
      width: 300,
      modal: true,
      title: title,
    });
  };

  utils.isValidEmailAddress = function (emailAddress) {
    var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(emailAddress);
  };

  utils.htmlEncode = function (value) {
    return $("<div/>").text(value).html();
  };

  utils.htmlDecode = function (value) {
    return $("<div/>").html(value).text();
  };

  // requestAnimationFrame() shim by Paul Irish
  // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
  window.requestAnimFrame = (function () {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (/* function */ callback) {
        window.setTimeout(callback, 1000 / 60);
      }
    );
  })();

  window.requestTimeout = function (fn, delay) {
    if (
      !window.requestAnimationFrame &&
      !window.webkitRequestAnimationFrame &&
      !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) && // Firefox 5 ships without cancel support
      !window.oRequestAnimationFrame &&
      !window.msRequestAnimationFrame
    )
      return window.setTimeout(fn, delay);

    var start = new Date().getTime(),
      handle = new Object();

    function loop() {
      var current = new Date().getTime(),
        delta = current - start;

      delta >= delay ? fn.call() : (handle.value = requestAnimFrame(loop));
    }

    handle.value = requestAnimFrame(loop);
    return handle;
  };
})((window.el.Utils = window.el.Utils || {}), jQuery);
